import RecallHistory from './RecallHistory';

export default RecallHistory;
